import state from './moduleLicenseEditState.js'
import mutations from './moduleLicenseEditMutations.js'
import actions from './moduleLicenseEditActions.js'
import getters from './moduleLicenseEditGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
